<template>
  <div v-if="item" class="row body__modal-formulario-beneficio">
    <!--Logo-->
    <!--Cargador de imagen para cargar beneficios de admin-->
    <div class="mb-3" v-if="esAdmin && permiteEditar">
      <CargadorImagen ref="cargadorImagen" />
      <p class="info-bajo-input">
        Si no se elige un logo, se mostrará el logo del Comercio en los
        catálogos.
      </p>
    </div>

    <!--Imagen fija para beneficios pendientes de admin y para beneficios de vista comerciante-->
    <div class="img-beneficio" v-if="(esAdmin && !permiteEditar) || !esAdmin">
      <div v-if="item.logoUrl">
        <img v-bind:src="UrlBase + 'images/logos/' + item.logoUrl" />
      </div>
      <div class="img-beneficio--sin-logo" v-else>
        <p class="info-bajo-input">
          Sin logo.
        </p>
      </div>
    </div>

    <!-- Comercio -->
    <div v-if="!comercioFijo" class="col-md-6 col-lg-4">
      <SelectorComercio ref="selectorComercio" :idActual="item.idComercio" :disabled="editando || !permiteEditar"
        :list="comercioList" v-on:evento-seleccionado="comercioSeleccionado($event)" class="leible mb-3" required />
    </div>

    <!-- Nombre de beneficio -->
    <div class="col-md-6 col-lg-4">
      <div class="form-floating mb-3">
        <input v-model="item.nombre" :readonly="!permiteEditar" maxlength="40" type="text" class="form-control"
          id="floatingNombre" placeholder="Nombre de ejemplo" required />
        <label for="floatingNombre">Nombre</label>
      </div>
    </div>

    <!-- Categoría y SubCategoría -->
    <SelectorCategoria required claseSelects="leible col-md-6 col-lg-4" :disabled="!permiteEditar"
      :idSubCategoria="item.idSubCategoria" v-on:subcategoria-cambiada="subCategoriaCambiada($event)" />

    <!-- Prioridad -->
    <div v-if="permitePrioridad" class="col-md-6 col-lg-4">
      <div class="form-floating mb-3">
        <input v-model="item.prioridad" :readonly="!permiteEditar" type="number" class="form-control"
          id="floatingPrioridad" placeholder="0" required />
        <label for="floatingPrioridad">Prioridad</label>
      </div>
    </div>

    <!-- Permite invitado -->
    <div class="leible col-md-6 col-lg-4">
      <div class="form-check mb-3">
        <input :disabled="!permiteEditar" class="form-check-input" type="checkbox" value="" id="defaultCheck1"
          v-model="item.permiteInvitado" />
        <label class="form-check-label" for="defaultCheck1">
          Permite invitado
        </label>
      </div>
    </div>

    <!-- Label Boton Libre -->
    <div class="col-md-6 col-lg-4">
      <div class="form-floating mb-3">
        <input v-model="item.labelBotonLibre" :readonly="!permiteEditar" maxlength="40" type="text" class="form-control"
          id="floatingLabelBotonLibre" placeholder="Texto de ejemplo" />
        <label for="floatingLabelBotonLibre">Texto Botón Libre <small>(opcional)</small></label>
      </div>
    </div>

    <!-- Url Boton Libre -->
    <div class="col-md-6 col-lg-4">
      <div class="form-floating mb-3">
        <input v-model="item.urlBotonLibre" :readonly="!permiteEditar" maxlength="100" type="url" class="form-control"
          id="floatingUrlBotonLibre" placeholder="https://www.sitioweb.com/"
          pattern="^(http(s?):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$" />
        <label for="floatingUrlBotonLibre">Link Botón Libre <small>(opcional)</small></label>
        <small class="invalid-feedback">
          Formato válido: http(s)://www.ejemplo.com
        </small>
      </div>
    </div>

    <!-- Tags-->
    <div class="box-form-custom box-form-custom--tag">
      <label class="form-label">Tags</label>
      <vue-tags-input placeholder="Escribe un Tag y presiona Enter" pattern="^[^,]*$"  v-model="tag" :tags="item.tags"
        @tags-changed="newTags => item.tags = newTags" />
    </div>

    <!-- Habilitar/deshabilitar -->
    <div class="mb-3">
      <input v-model="item.activo" class="form-check-input" type="checkbox" value="" id="checkActivo"
        :disabled="!permiteEditar" />
      <label class="form-check-label" for="checkActivo">
        Activo
      </label>
    </div>

    <!-- Texto Libre de Descripcion -->
    <div class="mb-3">
      <label class="form-label">Descripción del beneficio <small>(opcional)</small></label>
      <vue-editor v-model="item.description" :disabled="!permiteEditar" />
    </div>

    <!-- Contenedor de Código de descuentos -->
    <div class="box-form-custom" v-if="esAdmin && permiteEditar">
      <!-- Checkbox Código de descuentos -->
      <div class="mb-3">
        <input v-model="usaCodigoDescuento" @change="limpiarTipoCodigo()" class="form-check-input" type="checkbox"
          value="" id="checkTipoCodigo" />
        <label class="form-check-label" for="checkTipoCodigo">
          Usa código de descuentos
        </label>
      </div>

      <!-- Sub-seccion de Código de descuentos -->
      <div class="row mb-3 justify-content-center align-items-center" v-if="usaCodigoDescuento">
        <!-- Radio buttons para tipos de Código de descuentos -->
        <div class="form-check col-lg-4 mb-3" v-for="tc in tiposCodigoList" v-bind:key="tc.id">
          <input v-model="item.idTipoCodigo" v-bind:value="tc.id" class="form-check-input" type="radio"
            name="flexRadioDefault" id="flexRadioDefault1" />
          <label class="form-check-label" for="flexRadioDefault1">
            Código {{ tc.descripcion }}
          </label>
        </div>

        <!-- Texto Botón Código -->
        <div class="col-md-6 col-lg-4">
          <div class="form-floating mb-3">
            <input v-model="item.labelBotonCodigo" :readonly="!permiteEditar" maxlength="40" type="text"
              class="form-control" id="floatingLabelBotonCodigo" placeholder="Texto de ejemplo" />
            <label for="floatingLabelBotonCodigo" class="label-boton-codigo">Texto Botón Código
            </label>
          </div>
        </div>
      </div>
    </div>
    <!-- Días habilitados -->
    <week-day-picker v-model="item.diasHabilitados" :disabled="!permiteEditar" class="mb-3">
      <template slot="label">Días habilitados</template>
    </week-day-picker>

    <div class="tipos-descuento__crear-beneficio">
      <!-- Medio de pago -->
      <div class="medio-pago-lim-desc">
        <div class="col-md-6 col-lg-4">
          <div class="form-floating mb-3">
            <input v-model="item.medioPago" :readonly="!permiteEditar" maxlength="40" type="text" class="form-control"
              id="floatingMedioPago" placeholder="Efectivo" />
            <label for="floatingMedioPago">Medio de Pago</label>
          </div>
        </div>

        <div class="col-md-6 col-lg-4">
          <div class="form-floating mb-3">
            <input v-model="item.limiteDescuento" :readonly="!permiteEditar" :disabled="unidad !== '%'" type="number"
              class="form-control" id="floatingLimiteDescuento" placeholder="Límite descuento" />
            <label for="floatingLimiteDescuento">Límite de descuento ($)</label>
          </div>
        </div>
      </div>

      <!-- Sub-seccion de tipos de unidades de descuentos -->
      <div v-if="permiteEditar" class="row mb-3 justify-content-center align-items-center check-input__tipos-descuento">
        <!-- Titulo: Descuentos Multiples -->
        <h5>Tipos de Descuento:</h5>

        <!-- Bloque para checkbox Usa QR -->
        <div class="mb-3" v-if="ShowQRCheck">
          <input v-model="item.usaQR" class="form-check-input" type="checkbox" value="" id="checkUsaQR" />
          <label class="form-check-label" for="checkUsaQR">
            Usa código QR
          </label>
        </div>

        <!-- Bloque para checkbox Usa Tienda -->
        <div class="mb-3" v-if="ShowTiendaCheck">
          <input v-model="item.usaTienda" class="form-check-input" type="checkbox" value="" id="checkUsaTienda" />
          <label class="form-check-label" for="checkUsaTienda">
            Usa Tienda
          </label>
        </div>


        <!-- Radio buttons para tipos de unidades descuentos -->
        <div class="form-check col-lg-3 mb-3 " v-for="ud in unidadesDescuentoList" v-bind:key="ud.valor">
          <input v-model="unidad" v-bind:value="ud.valor" class="form-check-input" type="radio" name="radioDescuento"
            :id="`radioDescuento${ud.valor}`" @change="descuento = null" />
          <label class="form-check-label" :for="`radioDescuento${ud.valor}`">
            {{ ud.descripcion }} {{ ud.valor == "T" ? "" : `(${ud.valor})` }}
          </label>
        </div>
      </div>

      <!-- Agregar descuentos -->
      <div v-if="permiteEditar" class="tipos-descuento">
        <!-- Valor del descuento -->
        <div class="descuento-porcentaje">
          <span class="label__tipos-descuento">Valor</span>
          <input type="number" class="form-control" placeholder="Entre 0 y 100" aria-label="Ingrese aquí"
            aria-describedby="basic-addon1" maxlength="2" min="0" max="100" @change="validarPorcentajeDescuento($event)"
            v-model="descuento" v-if="unidad == '%'" />
          <input type="number" class="form-control" placeholder="1234567890" aria-label="Ingrese aquí"
            aria-describedby="basic-addon1" min="0" v-model="descuento" v-if="unidad == '$'"
            @change="validarBonificacionDescuento($event)" />
          <div v-if="unidad == 'x'" class="descuento-2-x-1 d-flex align-items-center">
            <input v-model="unidadPromo1" placeholder="1-9" type="number" class="form-control" aria-label="Ingrese aquí"
              aria-describedby="basic-addon1" min="1" max="9" @change="validarPromoDescuento1($event)"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
            <span class="mx-2">x</span>
            <input v-model="unidadPromo2" placeholder="1-9" type="number" class="form-control" aria-label="Ingrese aquí"
              aria-describedby="basic-addon1" min="1" max="9" @change="validarPromoDescuento2($event)"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
          </div>
          <input type="text" class="form-control" placeholder="Texto promoción" aria-label="Ingrese aquí"
            aria-describedby="basic-addon1" min="0" v-model="descuento" v-if="unidad == 'T'" />
        </div>
        <!-- Tipo de Descuento -->
        <div class="tipo-descuento">
          <span class="label__tipos-descuento">Tipo de Descuento</span>
          <select class="custom-select" v-model="item.idTipoDescuento" @change="seleccionarTipoDescuento($event)">
            <option v-for="tipoDescuento in tipoDescuentos" v-bind:key="tipoDescuento.id"
              v-bind:value="tipoDescuento.id">
              {{ tipoDescuento.nombre }}
            </option>
          </select>
        </div>
      </div>
      <!-- Boton agregar descuento a Lista de Descuentos-->
      <div v-if="permiteEditar">
        <button class="btn btn-success btn-decuento" @click.prevent="agregarDescuento()">
          + Descuento
        </button>
      </div>
    </div>
    <!-- Lista de Descuentos -->
    <div class="table-responsive">
      <table id="tablaDescuentos" class="table table-hover">
        <thead>
          <tr>
            <th>Key</th>
            <th>Tipo Descuento</th>
            <th>Descuento</th>
            <th v-if="permiteEditar">Me Arrepiento</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="descuento in item.descuentos" v-bind:key="descuento.idTipoDescuento">
            <td>{{ descuento.idTipoDescuento }}</td>
            <td>{{ descuento.tipoDescuento }}</td>
            <td v-if="descuento.unidad == 'x'">
              {{ descuento.descuento.split(".")[0] }}{{ descuento.unidad
              }}{{ descuento.descuento.split(".")[1] }}
            </td>
            <td v-else>
              <span>{{ descuento.unidad == "$" ? descuento.unidad : "" }}</span>{{ descuento.descuento
              }}<span>{{
                descuento.unidad == "%" ? descuento.unidad : ""
                }}</span>
            </td>
            <!-- Botón quitar -->
            <td v-if="permiteEditar">
              <button type="button" class="btn btn-danger" @click="quitarDescuento(descuento)">
                <font-awesome-icon :icon="Icons.ELIMINAR" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { Icons as IconConstants } from "../../../constants";
import SelectorCategoria from "../util/SelectorCategoria";
import SelectorComercio from "../util/SelectorComercio";
import CargadorImagen from "../../util/CargadorImagen";
import WeekDayPicker from "../../util/WeekDayPicker.vue";
import { VueEditor } from "vue2-editor";
import { environment } from "../../../environments/environment";
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  components: {
    FontAwesomeIcon,
    VueTagsInput,
    SelectorCategoria,
    SelectorComercio,
    CargadorImagen,
    WeekDayPicker,
    VueEditor,
  },
  props: {
    /** Si es verdadero, el comercio no se podrá cambiar */
    comercioFijo: {
      type: Boolean,
      default: false,
    },
    comercioList: Array,
    editando: Boolean,
    /** Utilizado para cargar y guardar datos */
    facade: Function,
    item: Object,
    /** Si no se permisi, eso esta faltando. Estoy viendo ahora de donde sacarlo
te editar, los campos serán de solo lectura */
    permiteEditar: {
      type: Boolean,
      default: true,
    },
    /** Si se permite editar la prioridad */
    permitePrioridad: {
      type: Boolean,
      default: true,
    },
    esAdmin: {
      type: Boolean,
      default: true,
    },
    tiposCodigoList: Array,
  },
  data() {
    return {
      descuento: null,
      tipoDescuentos: [],
      usaCodigoDescuento: false,
      usaQR: false,
      usaTienda: false,
      unidad: "%",
      unidadPromo1: null,
      unidadPromo2: null,
      unidadesDescuentoList: [],
      tag: '',
    };
  },
  computed: {
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    UrlBase() {
      return environment.API_URL;
    },

    // Sirve para verificar las condiciones para mostrar o no el bloque de checkbox de qr
    ShowQRCheck() {
      // Si es comerciante, no debe mostrarlo
      if (!this.esAdmin && this.permiteEditar) return false;
      // Si es admin, debe mostrarlo
      if (this.esAdmin && this.permiteEditar) return true;
      // Si es admin y ve los beneficios pendientes
      return false;
    },
     ShowTiendaCheck() {
      // Si es comerciante, no debe mostrarlo
      if (!this.esAdmin && this.permiteEditar) return false;
      // Si es admin, debe mostrarlo
      if (this.esAdmin && this.permiteEditar) return true;
      // Si es admin y ve los beneficios pendientes
      return false;
    }
  },
  watch: {
    item(nuevo, viejo) {
      if (this.item.limiteDescuento == -1) {
        this.item.limiteDescuento = "";
      }
      if (!viejo || viejo.id != nuevo.id) {
        this.cargarTiposDescuento();
      }
      this.usaCodigoDescuento = nuevo && nuevo.idTipoCodigo;
    },
  },
  methods: {
    limpiarTipoCodigo() {
      if (!this.usaCodigoDescuento) {
        this.item.idTipoCodigo = null;
        this.item.labelBotonCodigo = null;
      }
    },
    limpiarPondImagen() {
      // Borra el logo del input
      this.$refs.cargadorImagen.EventoLimpiar();
    },
    limpiarValorDescuento() {
      this.unidadPromo1 = null;
      this.unidadPromo2 = null;
      this.unidad = "%";
      this.descuento = null;
    },
    callEventoCargarURL(urlAbsoluta) {
      this.$refs.cargadorImagen.EventoCargarURL(urlAbsoluta);
    },
    getArchivoLogo() {
      return this.$refs.cargadorImagen.getArchivo();
    },
    getEstadoLogo() {
      return this.$refs.cargadorImagen.estado;
    },

    // Envento click Agregar Descuento a la Lista.
    agregarDescuento() {
      // Mensajes de error
      if (!this.item.idTipoDescuento || this.item.idTipoDescuento <= 0) {
        Swal.fire({
          icon: "error",
          title: "Problemas",
          text: "Debe seleccionar un tipo de descuento.",
        });
      } else if (
        this.unidad == "%" &&
        (!this.descuento || this.descuento < 0 || this.descuento > 100)
      ) {
        Swal.fire({
          icon: "error",
          title: "Problemas",
          text: "El % de Descuento no es válido.",
        });
      } else if (
        this.unidad == "$" &&
        (!this.descuento || this.descuento < 0)
      ) {
        Swal.fire({
          icon: "error",
          title: "Problemas",
          text: "El valor de Bonificación no es válido.",
        });
      } else if (
        this.unidad == "x" &&
        (!this.unidadPromo1 ||
          this.unidadPromo1 < 0 ||
          this.unidadPromo1 > 9 ||
          !this.unidadPromo2 ||
          this.unidadPromo2 < 0 ||
          this.unidadPromo2 > 9)
      ) {
        Swal.fire({
          icon: "error",
          title: "Problemas",
          text: "El valor de Oferta no es válido.",
        });
      } else if (this.unidad == "T" && !this.descuento) {
        Swal.fire({
          icon: "error",
          title: "Problemas",
          text: "El valor de Promoción no es válido.",
        });
      } else {
        if (!this.item.descuentos) {
          this.item.descuentos = [];
        }

        if (this.unidad == "x") {
          this.descuento = this.unidadPromo1 + "." + this.unidadPromo2;
        }
        // Chequeo que no exista el tipo de descuento en la lista final de descuentos
        for (let index = 0; index < this.item.descuentos.length; index++) {
          const element = this.item.descuentos[index];
          if (this.item.idTipoDescuento == element.idTipoDescuento) {
            Swal.fire({
              icon: "error",
              title: "Problemas",
              text:
                "Para agregar este Descuento debe eliminar el descuento: " +
                element.tipoDescuento,
            });
            return;
          }
        }
        let descuentoSeleccionado = {
          idTipoDescuento: Number,
          tipoDescuento: String,
          descuento: String,
          unidad: String,
        };
        this.tipoDescuentos.forEach((tipoDescuentoSelf) => {
          if (tipoDescuentoSelf.id == this.item.idTipoDescuento) {
            descuentoSeleccionado.idTipoDescuento = tipoDescuentoSelf.id;
            descuentoSeleccionado.tipoDescuento = tipoDescuentoSelf.nombre;
            descuentoSeleccionado.descuento = String(this.descuento);
            descuentoSeleccionado.unidad = this.unidad;
          }
        });

        this.item.descuentos.push(descuentoSeleccionado);
        this.descuento = null;
        this.unidadPromo1 = null;
        this.unidadPromo2 = null;
        // Poner unidad por default para mostrar en radio button
        this.unidad = "%";
      }
    },
    // Trae los tiposDescuentos desde la api
    cargarTiposDescuento() {
      this.facade.getTipoDescuentoList().then((response) => {
        this.tipoDescuentos = response.data;
      });
    },
    cargarUnidadesTiposDescuento() {
      this.facade.getUnidadesDescuentoList().then((response) => {
        this.unidadesDescuentoList = response.data;
      });
    },
    comercioSeleccionado(comercio) {
      this.item.idComercio = comercio.id;
    },
    // Envento click Quitar Descuento a la Lista.
    quitarDescuento(descuento) {
      let nuevoArrayDescuentos = [];
      this.item.descuentos.forEach((descuentoSelf) => {
        if (descuentoSelf.idTipoDescuento != descuento.idTipoDescuento) {
          nuevoArrayDescuentos.push(descuentoSelf);
        }
      });
      this.item.descuentos = nuevoArrayDescuentos;
      this.descuento = null;
    },
    seleccionarTipoDescuento: async function (event) {
      this.item.idTipoDescuento = event.target.value;
    },
    seleccionarUnidadDescuento: async function (event) {
      this.item.unidad = event.target.value;
    },
    validarPorcentajeDescuento(event) {
      if (!event.target.value || event.target.value < 0) {
        this.descuento = 0;
      } else if (event.target.value > 100) {
        this.descuento = 100;
      }
    },
    validarBonificacionDescuento(event) {
      if (!event.target.value || event.target.value < 0) {
        this.descuento = 0;
      }
    },
    validarPromoDescuento1(event) {
      if (
        !event.target.value ||
        event.target.value < 0 ||
        event.target.value > 9
      ) {
        this.unidadPromo1 = null;
        this.unidadPromo2 = null;
      }
    },
    validarPromoDescuento2(event) {
      if (
        !event.target.value ||
        event.target.value < 0 ||
        event.target.value > 9
      ) {
        this.unidadPromo1 = null;
        this.unidadPromo2 = null;
      }
    },
    subCategoriaCambiada(nuevoId) {
      this.item.idSubCategoria = nuevoId;
    },
  },
  mounted() {
    this.cargarTiposDescuento();
    this.cargarUnidadesTiposDescuento();
  },
};
</script>
<style>
.leible *:disabled,
.leible *:disabled~.form-check-label {
  opacity: 1;
  color: unset;
}
</style>
<style lang="scss">
.body__modal-formulario-beneficio {
  justify-content: center;
}

#tablaDescuentos td,
#tablaDescuentos td {
  vertical-align: baseline;
}

.img-beneficio {
  .img-beneficio--sin-logo {
    color: #41464b;
    background-color: #e2e3e5;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    padding: 1rem;
    margin-bottom: 1rem;
  }

  img {
    width: 60%;
    margin-bottom: 2rem;

    @media screen and (max-width: 991px) {
      width: 70%;
    }

    @media screen and (max-width: 575px) {
      width: 75%;
      margin-bottom: 1rem;
    }

    @media screen and (max-width: 450px) {
      width: 100%;
      margin-bottom: 1rem;
    }
  }
}

.box-form-custom {
  max-width: 97% !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  padding-top: 1rem;
  margin: 1rem 0.5rem;

  @media screen and (max-width: 991px) {
    max-width: 94% !important;
  }
}

.box-form-custom--tag {
  .vue-tags-input{
    max-width: 100%;
    margin-bottom: 1rem;
    .ti-tag{
      background-color: #198754 !important;
    }
  }
}

.descuento-porcentaje,
.tipo-descuento {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.descuento-porcentaje input,
.tipo-descuento select {
  width: 50%;
}

.btn-decuento {
  margin: 5px 0px 15px;
}

.label-boton-codigo {
  width: 100%;
}

.tipos-descuento__crear-beneficio {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-wrap: wrap;

  .label__tipos-descuento {
    display: flex;
    align-items: center;
  }

  .check-input__tipos-descuento {

    form-check-input:valid~.form-check-label,
    .form-check-input:valid {
      color: #2c3e50;
      border-color: #2c3e50;
    }

    .form-check-input:checked {
      background-color: #0d6efd !important;
      border-color: #0d6efd !important;
    }

    .form-check-input:focus {
      box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
    }

    .was-validated {
      color: #2c3e50 !important;
      border-color: #2c3e50 !important;
      background-color: #fff !important;
    }

    label,
    input {
      color: #2c3e50 !important;
      border-color: #2c3e50 !important;
    }
  }

  .tipos-descuento {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    align-content: center;

    input.form-control:valid,
    .custom-select:valid {
      background-image: none !important;
      border: 1px solid #ced4da !important;
    }

    input.form-control {
      padding-right: 1rem;
    }

    &>div {
      width: 76%;
      flex-direction: row;
      justify-content: flex-end;
      align-items: stretch;
      column-gap: 1rem;

      input,
      select {
        width: 20vw;
        max-width: 200px;
        min-width: 100px;
      }

      input {
        text-align: end;
        padding: 0;
      }
    }

    .descuento-2-x-1 {

      input,
      select {
        width: 88px;
        min-width: 88px;
        padding-right: 1px;

        @media screen and (max-width: 991px) {
          padding-right: 1px;
          width: 63px;
          min-width: 63px;
        }

        @media screen and (max-width: 575px) {
          padding-right: 5px;
        }
      }
    }
  }

  .medio-pago-lim-desc {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}

@media screen and (min-width: 401px) and (max-width: 993px) {
  .tipos-descuento__crear-beneficio {
    .tipos-descuento {
      &>div {
        width: 93%;

        input,
        select {
          width: 150px;
        }
      }
    }
  }
}

@media screen and (min-width: 1px) and (max-width: 400px) {
  .tipos-descuento__crear-beneficio {
    .tipos-descuento {
      &>div {
        width: 100%;

        input,
        select {
          width: 37vw;
          min-width: 100px;
          max-width: 250px;
        }
      }
    }

    .medio-pago-lim-desc {
      flex-direction: column;
    }
  }
}
</style>
